export const MENU_SETTINGS: Record<string, any> = {
	agent: [
		{
			icon: 'house',
			name: 'dashboard',
			label: 'Dashboard',
			url: '/agent/dashboard',
			children: [],
		},
		// {
		//   icon: "bookImage",
		//   name: "ban-hang",
		//   label: "Samtek Store",
		//   children: [
		//     {
		//       icon: "circle",
		//       name: "product-extra",
		//       label: "Bán hàng",
		//       url: "/agent/ban-hang/san-pham",
		//       children: [],
		//     },
		//     {
		//       icon: "circle",
		//       name: "salePayment",
		//       label: "Chờ thanh toán",
		//       url: "/agent/ban-hang/cho-thanh-toan",
		//       children: [],
		//     },

		//   ],
		// },
		{
			icon: 'package',
			name: 'done',
			label: 'Đơn hàng đội nhóm',
			url: '/agent/sub/orders/list',
			children: [],
		},
		{
			icon: 'fileBox',
			name: 'individual',
			label: 'Đơn hàng cá nhân',
			url: '/agent/sub/orders/individual',
			children: [],
		},
		{
			icon: 'headset',
			name: 'takeOfCare',
			label: 'Chăm sóc đơn hàng',
			url: '/agent/sub/orders/take-of-care',
			children: [],
		},
		// {
		//   icon: "bookImage",
		//   name: "abroadBusiness",
		//   label: "Di trú",
		//   children: [
		//     {
		//       icon: "circle",
		//       name: "processing",
		//       label: "HĐ chưa tính thưởng",
		//       url: "/agent/abroad/list-processing",
		//       children: [],
		//     },
		//     {
		//       icon: "circle",
		//       name: "done",
		//       label: "HĐ đã tính thưởng",
		//       url: "/agent/abroad/list-done",
		//       children: [],
		//     },
		//     {
		//       icon: "circle",
		//       name: "individual",
		//       label: "Cá nhân bán hàng",
		//       url: "/agent/abroad/individual",
		//       children: [],
		//     },
		//   ],
		// },
		// {
		//   icon: "heart",
		//   name: "lifeInsurance",
		//   label: "Nhân thọ",
		//   children: [
		//     {
		//       icon: "circle",
		//       name: "processing",
		//       label: "HĐ chưa tính thưởng",
		//       url: "/agent/life-insurance/processing",
		//       children: [],
		//     },
		//     {
		//       icon: "circle",
		//       name: "done",
		//       label: "HĐ đã tính thưởng",
		//       url: "/agent/life-insurance/list-done",
		//       children: [],
		//     },
		//     {
		//       icon: "circle",
		//       name: "feeDue",
		//       label: "Đến hạn đóng phí",
		//       url: "/agent/life-insurance/fee-due",
		//       children: [],
		//     },
		//     {
		//       icon: "circle",
		//       name: "lostEffective",
		//       label: "HĐ mất hiệu lực",
		//       url: "/agent/life-insurance/lost-effective",
		//       children: [],
		//     },
		//     {
		//       icon: "circle",
		//       name: "canceled",
		//       label: "Hợp đồng đã hủy",
		//       url: "/agent/life-insurance/canceled",
		//       children: [],
		//     },
		//     {
		//       icon: "circle",
		//       name: "individual",
		//       label: "Cá nhân bán hàng",
		//       url: "/agent/life-insurance/individual",
		//       children: [],
		//     },
		//   ],
		// },
		// {
		//   icon: "bookImage",
		//   name: "nonLifeInsurance",
		//   label: "Phi nhân thọ",
		//   children: [
		//     // {
		//     //   icon: "circle",
		//     //   name: "processing",
		//     //   label: "HĐ chưa tính thưởng",
		//     //   url: "/agent/non-life-insurance/list-processing",
		//     //   children: [],
		//     // },
		//     {
		//       icon: "circle",
		//       name: "done",
		//       label: "Đơn hàng đội nhóm",
		//       url: "/agent/non-life-insurance/list-done",
		//       children: [],
		//     },
		//     {
		//       icon: "circle",
		//       name: "individual",
		//       label: "Đơn hàng cá nhân",
		//       url: "/agent/non-life-insurance/individual",
		//       children: [],
		//     },
		//   ],
		// },
		{
			icon: 'folder',
			name: 'documents',
			label: 'Tài liệu kinh doanh',
			url: '/agent/documents',
			children: [],
		},
		{
			icon: 'bell',
			name: 'programs',
			label: 'Chương trình thi đua',
			url: '/agent/notifications/programs',
			children: [],
		},
		{
			icon: 'fileText',
			name: 'notifications-list',
			label: 'Danh sách tin tức',
			url: '/agent/notifications/list',
			children: [],
		},
		// {
		//   icon: "calendar",
		//   name: "meeting",
		//   label: "Danh sách lịch họp",
		//   url: "/agent/notifications/meeting",
		//   children: [],
		// },
		{
			icon: 'banknote',
			name: 'commissionTable',
			label: 'Bảng kê thu nhập',
			url: '/agent/commission-table',
			children: [],
		},
		{
			icon: 'userRounded',
			name: 'customers',
			label: 'Khách hàng',
			url: '/agent/customers',
			children: [],
		},
		{
			icon: 'usersRounded',
			name: 'member',
			label: 'Thành viên',
			children: [
				{
					icon: 'circle',
					name: 'list',
					label: 'Danh sách',
					url: '/agent/members/list',
					children: [],
				},
				{
					icon: 'circle',
					name: 'tree',
					label: 'Cây thành viên',
					url: '/agent/members/tree',
					children: [],
				},
				{
					icon: 'circle',
					name: 'level-up-report',
					label: 'Báo cáo thăng tiến',
					url: '/agent/members/level-up-report',
					children: [],
				},
				{
					icon: 'circle',
					name: 'level-up-log',
					label: 'Lịch sử thăng tiến',
					url: '/agent/members/level-up-log',
					children: [],
				},
			],
		},
		{
			icon: 'circleUser',
			name: 'profile',
			label: 'Hồ sơ cá nhân',
			url: '/agent/profile',
			children: [],
		},
	],
	staff: [
		{
			icon: 'house',
			name: 'dashboard',
			label: 'Dashboard',
			url: '/staff/dashboard',
			id_form: 0,
			children: [],
		},
		// {
		//   icon: "bookImage",
		//   name: "emigrant",
		//   label: "Di trú",
		//   children: [
		//     {
		//       icon: "circle",
		//       name: "processing",
		//       label: "HĐ chưa tính thưởng",
		//       url: "/staff/abroad/list-processing",
		//       id_form: 10067,
		//       children: [],
		//     },
		//     {
		//       icon: "circle",
		//       name: "done",
		//       label: "HĐ đã tính thưởng",
		//       url: "/staff/abroad/list-done",
		//       id_form: 10068,
		//       children: [],
		//     },
		//     {
		//       icon: "circle",
		//       name: "profix",
		//       label: "Lợi nhuận gộp",
		//       url: "/staff/abroad/profix",
		//       id_form: 10069,
		//       children: [],
		//     },
		//     {
		//       icon: "circle",
		//       name: "profixDetailAll",
		//       label: "Chi tiết lợi nhuận gộp",
		//       url: "/staff/abroad/profix-detail-all",
		//       id_form: 10070,
		//       children: [],
		//     },
		//     {
		//       icon: "circle",
		//       name: "commissionList",
		//       label: "Tính thưởng hợp đồng",
		//       url: "/staff/abroad/commission-list",
		//       id_form: 10071,
		//       children: [],
		//     },
		//     {
		//       icon: "circle",
		//       name: "paidoutList",
		//       label: "Thanh toán thành viên",
		//       url: "/staff/abroad/paidout-list",
		//       id_form: 10072,
		//       children: [],
		//     },
		//     {
		//       icon: "circle",
		//       name: "paidoutDetail",
		//       label: "Chi tiết thanh toán",
		//       url: "/staff/abroad/paidout-detail",
		//       id_form: 10073,
		//       children: [],
		//     },
		//     {
		//       icon: "circle",
		//       name: "products",
		//       label: "Sản phẩm",
		//       url: "/staff/abroad/products",
		//       id_form: 10066,
		//       children: [],
		//     },
		//     {
		//       icon: "circle",
		//       name: "providers",
		//       label: "Nhà cung cấp",
		//       url: "/staff/abroad/providers",
		//       id_form: 10065,
		//       children: [],
		//     },
		//   ],
		// },
		// {
		//   icon: "heart",
		//   name: "lifeInsurance",
		//   label: "Nhân thọ",
		//   children: [
		//     {
		//       icon: "circle",
		//       name: "processing",
		//       label: "HĐ chưa tính thưởng",
		//       url: "/staff/life-insurance/list-processing",
		//       id_form: 23,
		//       children: [],
		//     },
		//     {
		//       icon: "circle",
		//       name: "done",
		//       label: "HĐ đã tính thưởng",
		//       url: "/staff/life-insurance/list-done",
		//       id_form: 24,
		//       children: [],
		//     },
		//     {
		//       icon: "circle",
		//       name: "canceled-staff",
		//       label: "Hợp đồng đã hủy",
		//       url: "/staff/life-insurance/list-canceled",
		//       id_form: 10063,
		//       children: [],
		//     },
		//     {
		//       icon: "circle",
		//       name: "commissionList",
		//       label: "Tính thưởng hợp đồng",
		//       url: "/staff/life-insurance/commission-list",
		//       id_form: 38,
		//       children: [],
		//     },
		//     {
		//       icon: "circle",
		//       name: "paidoutList",
		//       label: "Thanh toán thành viên",
		//       url: "/staff/life-insurance/paidout-list",
		//       id_form: 40,
		//       children: [],
		//     },
		//     {
		//       icon: "circle",
		//       name: "paidoutDetail",
		//       label: "Chi tiết thanh toán",
		//       url: "/staff/life-insurance/paidout-detail",
		//       id_form: 55,
		//       children: [],
		//     },

		//     // {
		//     // 	icon: 'circle',
		//     // 	name: 'resolvingBenefits',
		//     // 	label: 'Resolving Benefits',
		//     // 	url: '/staff/life-insurance/resolving-benefits',
		//     // 	children: [],
		//     // },
		//     {
		//       icon: "circle",
		//       name: "products",
		//       label: "Sản phẩm",
		//       url: "/staff/life-insurance/products",
		//       id_form: 20,
		//       children: [],
		//     },
		//     {
		//       icon: "circle",
		//       name: "providers",
		//       label: "Nhà cung cấp",
		//       url: "/staff/life-insurance/providers",
		//       id_form: 18,
		//       children: [],
		//     },
		//   ],
		// },
		{
			icon: 'bookImage',
			name: 'sub-order',
			label: 'Quản lý đơn',
			children: [
				{
					icon: 'circle',
					name: 'order-list',
					label: 'Danh sách đơn',
					url: '/staff/sub/orders/list',
					id_form: 21,
					children: [],
				},
				{
					icon: 'circle',
					name: 'feeDue',
					label: 'Chăm sóc đơn',
					url: '/staff/sub/orders/take-of-care',
					id_form: 29,
					children: [],
				},
				{
					icon: 'circle',
					name: 'order-canceled',
					label: 'Đơn đã huỷ',
					url: '/staff/sub/orders/canceled',
					id_form: 22,
					children: [],
				},
				{
					icon: 'circle',
					name: 'lostEffective',
					label: 'HĐ mất hiệu lực',
					url: '/staff/sub/lost-effective',
					id_form: 30,
					children: [],
				},
				{
					icon: 'circle',
					name: 'financial',
					label: 'Tư vấn tài chính',
					url: '/staff/sub/financial',
					id_form: 25,
					children: [],
				},
				// {
				//   icon: "circle",
				//   name: "paidoutList",
				//   label: "Thanh toán thành viên",
				//   url: "/staff/sub/paidout-list",
				//   id_form: 39,
				//   children: [],
				// },
				// {
				//   icon: "circle",
				//   name: "paidoutDetail",
				//   label: "Chi tiết thanh toán",
				//   url: "/staff/sub/paidout-detail",
				//   id_form: 54,
				//   children: [],
				// },
				{
					icon: 'circle',
					name: 'commission-pass-config',
					label: 'Cấu hình thưởng vượt',
					url: '/staff/commission-pass-config',
					id_form: 10077,
					minProductId: 3, // Yêu cầu STARTER
					children: [],
				},
				{
					icon: 'circle',
					name: 'products',
					label: 'Sản phẩm',
					url: '/staff/sub/products',
					id_form: 19,
					children: [],
				},
				{
					icon: 'circle',
					name: 'providers',
					label: 'Nhà cung cấp',
					url: '/staff/sub/providers',
					id_form: 17,
					children: [],
				},
				{
					icon: 'circle',
					name: 'config-profile',
					label: 'Danh mục hồ sơ',
					url: '/staff/sub/config-profile',
					id_form: 10076,
					minProductId: 3, // Yêu cầu STARTER
					children: [],
				},
			],
		},
		{
			icon: 'chart',
			name: 'reports',
			label: 'Báo cáo tổng hợp',
			children: [
				{
					icon: 'circle',
					name: 'paidoutList',
					label: 'Thanh toán thành viên',
					url: '/staff/report/paidout-list',
					id_form: 39,
					children: [],
				},
				{
					icon: 'circle',
					name: 'reportpaidoutDetail',
					label: 'Chi tiết thanh toán',
					url: '/staff/report/paidout-detail',
					id_form: 54,
					children: [],
				},
				{
					icon: 'circle',
					name: 'profix',
					label: 'Lợi nhuận gộp',
					url: '/staff/sub/profix',
					id_form: 33,
					children: [],
				},
				{
					icon: 'circle',
					name: 'profixDetailAll',
					label: 'Chi tiết lợi nhuận gộp',
					url: '/staff/sub/profix-detail-all',
					id_form: 34,
					children: [],
				},
				{
					icon: 'circle',
					name: 'commissionList',
					label: 'Tính thưởng đơn hàng',
					url: '/staff/report/commission-list',
					id_form: 37,
					children: [],
				},
				{
					icon: 'circle',
					name: 'report-commission',
					label: 'Báo cáo doanh số',
					url: '/staff/report/commission',
					id_form: 57,
					children: [],
				},
				{
					icon: 'circle',
					name: 'totals',
					label: 'Tổng thành viên',
					url: '/staff/agents/totals',
					id_form: 10058,
					children: [],
				},
				{
					icon: 'circle',
					name: 'new-agents',
					label: 'Thành viên tuyển mới',
					url: '/staff/agents/new-agents',
					id_form: 10059,
					children: [],
				},
				{
					icon: 'circle',
					name: 'levelUpReport',
					label: 'Báo cáo thăng tiến',
					url: '/staff/agents/level-up-report',
					id_form: 35,
					children: [],
				},
				{
					icon: 'circle',
					name: 'promotionHistory',
					label: 'Lịch sử thăng tiến',
					url: '/staff/agents/level-up-log',
					id_form: 36,
					children: [],
				},
				{
					icon: 'circle',
					name: 'report-income-outcome',
					label: 'Báo cáo thu chi',
					url: '/staff/report/income-outcome',
					id_form: 10060,
					minProductId: 4, // Yêu cầu GROWTH
					children: [],
				},
				{
					icon: 'circle',
					name: 'escrow',
					label: 'Ký quỹ trong kỳ',
					url: '/staff/escrow',
					id_form: 47,
					minProductId: 5, // Yêu cầu BUSINESS
					children: [],
				},
				{
					icon: 'circle',
					name: 'escrow-report',
					label: 'Báo cáo ký quỹ',
					url: '/staff/escrow-report',
					id_form: 48,
					minProductId: 5, // Yêu cầu BUSINESS
					children: [],
				},
				{
					icon: 'circle',
					name: 'loginLog-agent-report',
					label: 'Thành viên đăng nhập',
					url: '/staff/report/login-logs',
					id_form: 59,
					children: [],
				},
				{
					icon: 'circle',
					name: 'notLoginLog-agent-report',
					label: 'TV chưa đăng nhập',
					url: '/staff/report/not-login-logs',
					id_form: 10074,
					children: [],
				},
			],
		},
		{
			icon: 'bell',
			name: 'notifications',
			label: 'Thông báo',
			children: [
				{
					icon: 'circle',
					name: 'programs',
					label: 'Chương trình thi đua',
					url: '/staff/notifications/programs',
					id_form: 44,
					children: [],
				},
				{
					icon: 'circle',
					name: 'list',
					label: 'Danh sách tin tức',
					url: '/staff/notifications/list',
					id_form: 8,
					children: [],
				},
				{
					icon: 'circle',
					name: 'featured',
					label: 'Thông báo nổi bật',
					url: '/staff/notifications/featured',
					id_form: 9,
					children: [],
				},
				// {
				//   icon: "circle",
				//   name: "meeting",
				//   label: "Danh sách lịch họp",
				//   url: "/staff/meeting",
				//   id_form: 52,
				//   children: [],
				// },
			],
		},
		{
			icon: 'folder',
			name: 'documents',
			label: 'Tài liệu',
			children: [
				{
					icon: 'circle',
					name: 'members',
					label: 'Tài liệu kinh doanh',
					url: '/staff/documents/members',
					id_form: 6,
					children: [],
				},
				{
					icon: 'circle',
					name: 'members-internal',
					label: 'Tài liệu nội bộ',
					url: '/staff/documents/member-internal',
					id_form: 51,
					children: [],
				},
				{
					icon: 'circle',
					name: 'types',
					label: 'Loại tài liệu kinh doanh',
					url: '/staff/documents/types',
					id_form: 5,
					children: [],
				},
				{
					icon: 'circle',
					name: 'types-internal',
					label: 'Loại tài liệu nội bộ',
					url: '/staff/documents/type-internal',
					id_form: 50,
					children: [],
				},
				// {
				//   icon: "circle",
				//   name: "email-business",
				//   label: "Email doanh nghiệp",
				//   url: "/staff/documents/email-business",
				//   id_form: 10061,
				//   children: [],
				// },
			],
		},
		{
			icon: 'usersRounded',
			name: 'member',
			label: 'Thành viên',
			children: [
				{
					icon: 'circle',
					name: 'list',
					label: 'Danh sách',
					url: '/staff/agents/list',
					id_form: 26,
					children: [],
				},
				{
					icon: 'circle',
					name: 'tree',
					label: 'Cây thành viên',
					url: '/staff/agents/tree',
					id_form: 27,
					children: [],
				},
				{
					icon: 'circle',
					name: 'commission-table',
					label: 'Bảng kê thu nhập',
					url: '/staff/commission-table',
					id_form: 49,
					children: [],
				},

				// {
				// 	icon: 'circle',
				// 	name: 'electronicContracts',
				// 	label: 'Electronic Contracts',
				// 	url: '/staff/agents/electronic-contracts',
				// 	children: [],
				// },
				{
					icon: 'circle',
					name: 'assignLevel',
					label: 'Quản lý bổ nhiệm',
					url: '/staff/agents/assign-level',
					id_form: 31,
					children: [],
				},
				{
					icon: 'circle',
					name: 'changeManager',
					label: 'Quản lý chuyển nhánh',
					url: '/staff/agents/change-manager',
					id_form: 32,
					children: [],
				},
				{
					icon: 'circle',
					name: 'agent-econtract',
					label: 'Hợp đồng hợp tác',
					url: '/staff/agents/agent-econtract',
					id_form: 53,
					minProductId: 4, // Yêu cầu GROWTH
					children: [],
				},
				// {
				// 	icon: 'circle',
				// 	name: 'choice-econtract',
				// 	label: 'Hợp đồng kinh doanh',
				// 	url: '/staff/agents/option-contract',
				// 	id_form: 10057,
				// 	children: [],
				// },
				{
					icon: 'circle',
					name: 'customers-list',
					label: 'Khách hàng',
					url: '/staff/customers',
					id_form: 28,
					children: [],
				},
				{
					icon: 'circle',
					name: 'loginLog-staff',
					label: 'Lịch sử đăng nhập',
					url: '/staff/agents/login-logs',
					id_form: 58,
					children: [],
				},
			],
		},
		{
			icon: 'dollarSign',
			name: 'incomeOutcome',
			label: 'Thu chi',
			children: [
				{
					icon: 'circle',
					name: 'commission-manual',
					label: 'Thưởng kinh doanh',
					url: '/staff/commission-manual',
					id_form: 46,
					children: [],
				},

				{
					icon: 'circle',
					name: 'cashbookTotal',
					label: 'Tổng hợp thu chi',
					url: '/staff/income-outcome/cashbook-total',
					id_form: 16,
					minProductId: 4, // Yêu cầu GROWTH
					children: [],
				},
				{
					icon: 'circle',
					name: 'cashbookIncome',
					label: 'Danh sách phiếu thu',
					url: '/staff/income-outcome/cashbook-income',
					id_form: 12,
					minProductId: 4, // Yêu cầu GROWTH
					children: [],
				},
				{
					icon: 'circle',
					name: 'cashbookOutcome',
					label: 'Danh sách phiếu chi',
					url: '/staff/income-outcome/cashbook-outcome',
					id_form: 13,
					minProductId: 4, // Yêu cầu GROWTH
					children: [],
				},
				{
					icon: 'circle',
					name: 'commission-period-list',
					label: 'Kỳ tính thưởng',
					url: '/staff/commission-period',
					id_form: 42,
					children: [],
				},
				// {
				//   icon: "circle",
				//   name: "escrow-return",
				//   label: "Hoàn trả ký quỹ",
				//   url: "/staff/escrow-return",
				//   id_form: 10062,
				//   children: [],
				// },
				{
					icon: 'circle',
					name: 'cashbookIncomeDeleted',
					label: 'Phiếu thu đã xóa',
					url: '/staff/income-outcome/cashbook-income-deleted',
					id_form: 14,
					minProductId: 4, // Yêu cầu GROWTH
					children: [],
				},
				{
					icon: 'circle',
					name: 'cashbookOutcomeDeleted',
					label: 'Phiếu chi đã xóa',
					url: '/staff/income-outcome/cashbook-outcome-deleted',
					id_form: 15,
					minProductId: 4, // Yêu cầu GROWTH
					children: [],
				},
				{
					icon: 'circle',
					name: 'income',
					label: 'Cấu hình mục thu',
					url: '/staff/income-outcome/income',
					id_form: 10,
					minProductId: 4, // Yêu cầu GROWTH
					children: [],
				},
				{
					icon: 'circle',
					name: 'outcome',
					label: 'Cấu hình mục chi',
					url: '/staff/income-outcome/outcome',
					id_form: 11,
					minProductId: 4, // Yêu cầu GROWTH
					children: [],
				},
				{
					icon: 'circle',
					name: 'commission-type',
					label: 'Cấu hình loại thưởng',
					url: '/staff/commission-type',
					id_form: 45,
					children: [],
				},
				{
					icon: 'circle',
					name: 'config-escrow',
					label: 'Cấu hình ký quỹ',
					url: '/staff/config-escrow',
					id_form: 60,
					minProductId: 5, // Yêu cầu BUSINESS
					children: [],
				},
			],
		},
		// {
		//   icon: "usersRounded",
		//   name: "staffs",
		//   label: "Nhân viên",
		//   children: [
		//     {
		//       icon: "circle",
		//       name: "list",
		//       label: "Danh sách",
		//       url: "/staff/staffs/list",
		//       id_form: 1,
		//       children: [],
		//     },
		//     {
		//       icon: "circle",
		//       name: "permissions",
		//       label: "Thiết lập quyền",
		//       url: "/staff/staffs/permissions",
		//       id_form: 3,
		//       children: [],
		//     },
		//     {
		//       icon: "circle",
		//       name: "loginLogs",
		//       label: "Lịch sử đăng nhập",
		//       url: "/staff/staffs/login-logs",
		//       id_form: 4,
		//       children: [],
		//     },
		//   ],
		// },
		{
			icon: 'briefcaseBusiness',
			name: 'company',
			label: 'Quản trị hệ thống',
			children: [
				{
					icon: 'circle',
					name: 'list',
					label: 'Danh sách nhân viên',
					url: '/staff/staffs/list',
					id_form: 1,
					minProductId: 3, // Yêu cầu STARTER
					children: [],
				},
				{
					icon: 'circle',
					name: 'permissions',
					label: 'Thiết lập quyền',
					url: '/staff/staffs/permissions',
					id_form: 3,
					minProductId: 3, // Yêu cầu STARTER
					children: [],
				},
				{
					icon: 'circle',
					name: 'loginLogs',
					label: 'Nhân viên đăng nhập',
					url: '/staff/staffs/login-logs',
					id_form: 4,
					minProductId: 3, // Yêu cầu STARTER
					children: [],
				},
				{
					icon: 'circle',
					name: 'config-level-up',
					label: 'Cấu hình thăng tiến',
					url: '/staff/config-level-up',
					id_form: 43,
					children: [],
				},
				{
					icon: 'circle',
					name: 'config-comission-table',
					label: 'Cấu hình bảng kê',
					url: '/staff/config-comission-table',
					id_form: 10075,
					children: [],
				},
			],
		},
	],
	samtek: [
		{
			icon: 'usersRounded',
			name: 'samtek-customers',
			label: 'Khách hàng',
			id_form: 4,
			children: [
				{
					icon: 'circle',
					name: 'list',
					label: 'Danh sách',
					url: '/samtek/customers',
					id_form: 1,
					children: [],
				},
				{
					icon: 'circle',
					name: 'order-list',
					label: 'Đơn hàng',
					url: '/samtek/order-list',
					id_form: 5,
					children: [],
				},
				{
					icon: 'circle',
					name: 'sub-guide',
					label: 'Hướng dẫn sử dụng',
					url: '/samtek/staffs/sub-guide',
					id_form: 6,
					children: [],
				},
				{
					icon: 'circle',
					name: 'products-list',
					label: 'Danh sách sản phẩm',
					url: '/samtek/product-list',
					id_form: 7,
					children: [],
				},
			],
		},
		{
			icon: 'usersRounded',
			name: 'samtek-staffs',
			label: 'Nhân viên',
			children: [
				{
					icon: 'circle',
					name: 'list',
					label: 'Danh sách',
					url: '/samtek/staffs/list',
					id_form: 1,
					children: [],
				},
				{
					icon: 'circle',
					name: 'permissions',
					label: 'Thiết lập quyền',
					url: '/samtek/staffs/permissions',
					id_form: 2,
					children: [],
				},
				{
					icon: 'circle',
					name: 'loginLogs',
					label: 'Lịch sử đăng nhập',
					url: '/samtek/staffs/login-logs',
					id_form: 3,
					children: [],
				},
			],
		},
	],
};
